<div>
  <div class="flex items-center justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'home.searchResults' | translate }}</h2>
    <button
      class="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100 transition-colors"
      (click)="onClose()"
      [title]="'common.close' | translate">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
  @for (appGroup of searchResults(); track appGroup.appKey) {
    <div class="mb-6">
      @if (!tag()) {
        <h3 class="text-md font-medium text-gray-700 mb-3 items-center flex">
          @if (appGroup.app.iconDataUrl) {
            <img [src]="appGroup.app.iconDataUrl" [alt]="appGroup.app.title" class="w-6 h-6 mr-1" />
          }
          <span>{{ appGroup.appKey }}</span>
        </h3>
      }
      @for (providerGroup of appGroup.providers; track providerGroup.providerKey) {
        <div
          [ngClass]="{
            'ml-4': tag() === null
          }"
          class="mb-4">
          <h4 class="text-sm font-medium text-gray-600 mb-2">{{ providerGroup.providerKey }}</h4>
          <ul class="space-y-2">
            @for (property of providerGroup.properties; track property.key) {
              <li>
                <div
                  class="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
                  [title]="property.name">
                  <div class="flex items-center gap-4 flex-1 min-w-0">
                    <div class="shrink-0 items-center flex">
                      <cmi-provider-type-icon [providerType]="property.typeName" />
                    </div>
                    <div class="flex flex-col min-w-0 flex-1">
                      <span class="text-base font-medium text-gray-900 truncate">
                        {{ property.name }}
                      </span>
                      @if (property.formatString) {
                        <span class="text-sm text-gray-500 truncate">
                          {{ 'contentProviders.format' | translate }}: {{ property.formatString }}
                        </span>
                      }
                    </div>
                  </div>
                  <div class="flex items-center gap-2 shrink-0">
                    @if (supportsFormatting(property.typeName)) {
                      <button
                        class="text-main group rounded flex items-center justify-center"
                        (click)="
                          toggleFormattedInsert(
                            appGroup.appKey,
                            providerGroup.providerKey,
                            property.key
                          )
                        "
                        [title]="'contentProviders.formattedInsert' | translate">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          class="size-6 group-hover:fill-cmi-gray-light">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M5.248 20.246H9.05m0 0h3.696m-3.696 0 5.893-16.502m0 0h-3.697m3.697 0h3.803" />
                        </svg>
                      </button>
                    }
                    <button
                      class="text-main group rounded flex items-center justify-center"
                      (click)="onAddProperty(property, providerGroup.providerKey)"
                      [title]="'contentProviders.add' | translate">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6 group-hover:fill-cmi-gray-light">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                      </svg>
                    </button>
                  </div>
                </div>
                @if (
                  isPropertyExpanded(appGroup.appKey, providerGroup.providerKey, property.name) &&
                  supportsFormatting(property.typeName)
                ) {
                  <div class="px-4 pb-4 border-t border-gray-200 bg-gray-50">
                    <cmi-property-format-form
                      [property]="property"
                      [initialFormatString]="property.formatString"
                      [insertMode]="true"
                      (applyFormat)="
                        onApplyFormattedProperty(
                          property,
                          providerGroup.providerKey,
                          $event.formatValue
                        )
                      " />
                  </div>
                }
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }
</div>
